import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    const vehicleTypeSelectorValue = getValueOrDefault(formConfig, formValues, 'vehicleSelector');
    const hasVehiclesInSystem = vehicleTypeSelectorValue.hasVehiclesInSystem === 'no' ? false : true;
    const entityType = vehicleTypeSelectorValue.entityType;
    const selectedOtherVehicleType = getValueOrDefault(formConfig, formValues, 'vehicleTypeOther').value;
    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-haendelsen';
            break;
        case 'beskriv-haendelsen':
            nextPage = 'vaelg-koeretoej';
            break;
        case 'vaelg-koeretoej':
            // No vehicle policies
            if (!hasVehiclesInSystem) {
                nextPage = 'har-dit-koeretoej-en-nummerplade';
                // Has policies
            } else {
                if (entityType === 'others') {
                    nextPage = 'vaelg-andet-koeretoej';
                } else {
                    nextPage = 'vaelg-skadezone';
                }
            }
            break;

        case 'vaelg-andet-koeretoej':
            nextPage = 'har-dit-koeretoej-en-nummerplade';
            break;

        case 'har-dit-koeretoej-en-nummerplade':
            if (hasVehiclesInSystem) {
                if (entityType === 'others' && selectedOtherVehicleType === 'other') {
                    nextPage = 'andet-koeretoej-skader';
                } else {
                    nextPage = 'vaelg-skadezone';
                }
            } else {
                if (entityType === 'others' || selectedOtherVehicleType === 'other') {
                    nextPage = 'andet-koeretoej-skader';
                } else {
                    nextPage = 'vaelg-skadezone';
                }
                break;
            }
            break;

        case 'vaelg-skadezone':
            nextPage = 'foerer';
            break;

        case 'andet-koeretoej-skader':
            nextPage = 'foerer';
            break;

        case 'foerer':
            const selectedDriver = getValueOrDefault(formConfig, formValues, 'whoDroveYourVehicle').value;
            const driverOptionsWhereExtraInfoIsRequired = [
                'myPartner',
                'someoneFromMyHousehold',
                'someoneOutsideOfMyHousehold'
            ];

            if (driverOptionsWhereExtraInfoIsRequired.includes(selectedDriver)) {
                nextPage = 'foerer-oplysninger';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'foerer-oplysninger':
            nextPage = 'dokumentation';
            break;

        /*     case 'politi':
            nextPage = 'dokumentation';
            break; */

        case 'dokumentation':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'i-hvilket-type-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'i-hvilket-type-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
